<template>
  <div>
   	<a-modal :title="title[postType]" :visible="postVisible" @cancel="postVisible = false"
					width="50%">
					<template slot="footer" v-if="postType == 2">
						<a-button key="back" @click="postVisible = false"> 取消 </a-button>
					</template>
					<a-form-model :model="postForm" ref="postFormRef" :label-col="{ span: 6 }"
						:wrapper-col="{ span: 18 }">
							<!-- 岗位详情 -->
                        <div v-if="postType==2">
						<div>
							<span class="sizeStyle" >基本信息</span>
						</div>
						<div class="baseContainer"> 
						<a-row>
                            <a-col :span="12">
								<a-form-model-item label="行业名称" >
									<span>{{postForm.industryName}}</span>
								</a-form-model-item>
							</a-col>
                            <a-col :span="12">
                                <a-form-model-item label="岗位名称">
									<span>{{postForm.postName}}</span>
								</a-form-model-item>
                            </a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="创建时间">
									<span>{{postForm.createTime}}</span>
								</a-form-model-item>
							</a-col>
							<a-col :span="12">
								<a-form-model-item label="更新时间">
									<span>{{postForm.updateTime}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<a-row>
							<a-col :span="12">
								<a-form-model-item label="创建人"  >
									<span>{{postForm.creator}}</span>
								</a-form-model-item>
							</a-col>
						</a-row>
						<div>
							<span class="sizeStyle" >危害因素</span>
						</div>
						<div class="baseContainer">
				            <a-row> 
					             <div class="">
						             <a-table :columns="columns" :data-source="harmfulData" :scroll="{ y: scroll_y }" bordered
						             :pagination="pagination4" @change="changeTableclaim4">
						            <span slot="index" slot-scope="text, record, index">
							           {{ (pagination4.current - 1) * pagination4.pageSize + index + 1 }}
						            </span>
					                </a-table>
					             </div>
							
				            </a-row> 
					   </div>
					</div>
				</div>
			</a-form-model>
		</a-modal>
  </div>
</template>

<script>
import {
  getUserListDetail,
  postInfo_details,
} from '@/api/Industry'
export default {
    props: [

    ],
    data() {
        return {
          scroll_y: 400,
			columns: [
				{
    title: '序号',
    dataIndex: 'index',
    key: 'index',
    scopedSlots: {
      customRender: 'index',
    },
    // width: 120,
    ellipsis: true,
  },
  {
    title: '危害因素名称',
    dataIndex: 'fullName',
    key: 'fullName',
  },
  {
    title: '单价(元)',
    dataIndex: 'price',
    key: 'price',
    // width: 80,
  },
			],
			postType: undefined,
            title: [
            '岗位列表-新增',
            '岗位列表-编辑',
            '岗位列表-详情'
        ],
        postVisible: false,
        postForm: {
            quotePostInfo: {
                industryId: '',
                postName: '',

            },
            quoteHarmFactorList: [
            {
              price: '',
              factorName: '',
            },
        ],
        },
		harmfulData: [],
		pagination4: {
            current: 1,
            pageSize: 10,
            total: 0,
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            showLessItems: true,
            showSizeChanger: true,
        },
        rowIdNow: '',
        }
        
    },
    methods: {
      //分页
     changeTableclaim4(pagination) {
    	this.pagination4.current = pagination.current
    	this.pagination4.pageSize = pagination.pageSize
    	this.geData()

    },
        //获取当前页面列表
      geData() {
             //获得详情列表harmfulData
			getUserListDetail({
                pageSize: this.pagination4.pageSize,
                pageNum: this.pagination4.current,
                postId:  this.rowIdNow,
            }).then((res) => {
             this.harmfulData = res.data
             console.log(this.harmfulData, 'this.harmfulData +++++++++++++++')
              const pagination = {
              ...this.pagination4,
            }
           pagination.total = res.total
            this.pagination4 = pagination
      })

        },
        init(data) {
            this.postVisible = true
			this.postType = data.postType
      this.rowIdNow = data.rowId
			if(data.postType == 2) {
				// 获得岗位详情
			 postInfo_details(data.rowId).then((res) => {
                console.log( res.data, ' res.data3333333333333333333333333========================')
                this.postForm = res.data
               })
			this.geData()
			}  else if(data.postType == 1) {
				//岗位编辑

			} 
			// else if(data.postType == 0) {
			// 	// 岗位新增

			// }


        }
    }

}
</script>

<style>

</style>